/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetFluiditeRatesResult } from '../../models/get-fluidite-rates-result';

export interface GetByRestaurantidFluiditerates$Params {
  RestaurantId: number;
}

export function getByRestaurantidFluiditerates(
  http: HttpClient,
  rootUrl: string,
  params: GetByRestaurantidFluiditerates$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<GetFluiditeRatesResult>> {
  const rb = new RequestBuilder(rootUrl, getByRestaurantidFluiditerates.PATH, 'get');
  if (params) {
    rb.path('RestaurantId', params.RestaurantId, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetFluiditeRatesResult>;
    }),
  );
}

getByRestaurantidFluiditerates.PATH = '/Restaurants/{RestaurantId}/fluiditeRates';
